// extracted by mini-css-extract-plugin
var _1 = "DisplayRowAction__Action___vKNwp";
var _2 = "DisplayRowAction__active___VXEKl";
var _3 = "DisplayRowAction__wiggle____EzhI";
export { _1 as "Action", _2 as "active", _3 as "wiggle" }
